import { Model } from 'dva'
import { AllowedFilters, AllowedObjectTypes, YamlValidatorReducerState } from './types'

const initialState: YamlValidatorReducerState = {
  isIssuesDrawerOpen: false,
  minimized: false,
  oneIssueActive: false,
  issues: [],
  currentIssue: null,
  filters: {
    categorizeBy: {
      value: 'message',
      allowedValues: ['message', 'object_type'],
    },
    object_type: {
      value: [],
      allowedValues: Object.values(AllowedObjectTypes),
    },
    issueType: {
      value: ['error'],
      allowedValues: ['error', 'warning'],
    },
  },
}

const InteractiveYamlValidator: Model = {
  namespace: 'yamlValidator',
  state: initialState,
  reducers: {
    setIssueDrawerStatus: (state, action) => {
      const { open } = action.payload
      return {
        ...state,
        isIssuesDrawerOpen: open,
      }
    },
    toggleIssuesModal: (state, action) => {
      const { open, issues } = action.payload
      return {
        ...state,
        isIssuesDrawerOpen: open,
        issues,
      }
    },
    setIssues: (state, action) => {
      const { issues } = action.payload
      if (!Array.isArray(issues)) {
        console.error('Received invalid issues type')
        return state
      }
      if (issues.find((i) => JSON.stringify(i) === JSON.stringify(state.currentIssue))) {
        return {
          ...state,
          issues,
        }
      }
      return {
        ...state,
        issues,
        currentIssue: null,
      }
    },
    setCurrentIssue: (state, action) => {
      const { issue } = action.payload
      if (!issue || issue === null) {
        return {
          ...state,
          currentIssue: null,
        }
      }
      if (!issue?.type) {
        console.error('Received invalid issue')
        return
      }
      return {
        ...state,
        currentIssue: issue,
      }
    },
    setFilter: (state, action) => {
      const { filterName, value }: { filterName: AllowedFilters; value: any | any[] } =
        action.payload

      if (!initialState.filters[filterName]) {
        console.error('Received invalid filter')
        return
      }
      return {
        ...state,
        filters: {
          ...state.filters,
          [filterName]: {
            ...state.filters[filterName],
            value: value,
          },
        },
      }
    },
    toggleMinimized: (state, action) => {
      const { minimized } = action.payload
      if (minimized) {
        return {
          ...state,
          minimized: true,
        }
      }
      return {
        ...state,
        minimized: false,
      }
    },
    toggleOneIssueActive: (state, action) => {
      const { oneIssueActive } = action.payload
      if (oneIssueActive) {
        return {
          ...state,
          oneIssueActive: true,
        }
      }
      return {
        ...state,
        oneIssueActive: false,
        currentIssue: null,
      }
    },
    resetYamlValidator: (state, action) => {
      return {
        ...state,
        ...initialState,
      }
    },
  },
}

export default InteractiveYamlValidator
